import * as types from "./simpleFetchActionTypes";

export default function simpleFetchReducer(state = {}, action) {
  switch (action.type) {
	case types.SHOW_TOAST: {
	  return action.value;
	}
	case types.RESET_TOAST: {
		return action.value
	}
	default: {
	  return state;
	}
  }
}


// WEBPACK FOOTER //
// ./utils/simpleFetchReducer.js